import { render } from "./OrderLibrary.vue?vue&type=template&id=5bfa2c84"
import script from "./OrderLibrary.vue?vue&type=script&lang=ts"
export * from "./OrderLibrary.vue?vue&type=script&lang=ts"
script.render = render

export default script